// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__228nd","col":"styles_col__bvip6"};